import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { queryProcessApplyForm, getApplyProcessFormByFormId, formFillSave } from '@/services/processApply';
import selectPerson from '@/components/select-person';
import { startProcess } from '@/services/myApply';
import { nextFlowNode, complete, saveFlowTrack } from '@/services/form';
import { queryNoticeFillDetails, querySendOutScope } from '@/api/notice/noticeApi.js';
export default {
  components: {
    selectPerson: selectPerson
  },
  data: function data() {
    var usersTabList = [{
      title: '组织',
      value: 0
    }, {
      title: '组织成员',
      value: 1
    }, {
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }, {
      title: '岗位成员',
      value: 5
    }];
    var processStatus = [{
      itemKey: '草稿',
      itemVal: 0
    }, {
      itemKey: '待审批',
      itemVal: 1
    }, {
      itemKey: '审批中',
      itemVal: 2
    }, {
      itemKey: '审批通过',
      itemVal: 3
    }, {
      itemKey: '审批驳回',
      itemVal: 4
    }, {
      itemKey: '审核作废',
      itemVal: 5
    }, {
      itemKey: '审核挂起',
      itemVal: 6
    }];
    return {
      advanced: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      form: {
        formName: ''
      },
      valueIndex: 0,
      usersList: {},
      usersTabList: usersTabList,
      checkItem: {},
      formName: 'formName',
      activeKey: ['1'],
      processApplyFormLists: [],
      visible: false,
      jsonData: {
        list: [],
        config: {
          labelWidth: 100,
          labelPosition: 'right',
          size: 'small',
          customClass: '',
          ui: 'antd',
          layout: 'horizontal',
          labelCol: 3,
          width: '100%',
          hideLabel: false,
          hideErrorMessage: false
        }
      },
      formObject: {
        organPostId: []
      },
      options: [],
      // 级联选择数据
      userInfo: this.$hdk.userInfo.get(),
      rules: {
        organPostId: [{
          required: true,
          message: '请选择所属组织及岗位'
        }]
      },
      moniList: [{
        cateId: 1,
        cateName: '出差',
        childNode: [{
          cateId: 1,
          cateName: '出差',
          childNode: null,
          formId: 14,
          formName: '教职员工出差审批单',
          postId: null,
          remarks: '全校教职工可申请',
          sort: 1
        }],
        formId: null,
        formName: null,
        postId: null,
        remarks: null,
        sort: null
      }]
    };
  },
  methods: {
    toFuza: function toFuza() {
      this.$router.push({
        path: '/formReview/reviewCenter/schoolRunSubmit'
      });
    },
    onClicCopyMeList: function onClicCopyMeList() {
      this.queryProcessApplyFormLists();
      // if (this.form.formName != '') {
      //     this.processApplyFormLists = this.moniList;
      // } else {
      //
      // }
    },
    cz: function cz() {
      this.$refs.searchFrom.resetFields();
    },
    /**
     * 列选择切换//锚点跳转
     */
    changeValueIndex: function changeValueIndex(index, id) {
      this.valueIndex = index;
      document.getElementById(id).scrollIntoView({
        behavior: 'smooth'
      });
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value) {
      var $set = this.$set,
        formObject = this.formObject;
      // 组织岗位赋值
      $set(formObject, 'organId', value[0]);
      $set(formObject, 'postId', value[1]);
      this.formObject.customize = {};
      this.formObject.customize.organId = value[0];
      this.formObject.customize.postId = value[1];

      // let newOrganIdAndPost = {
      //     organId: value[0],
      //     postId: value[1]
      // };
      // querySendOutScope(newOrganIdAndPost).then(res => {
      //     this.allDisabled = res.data.data;
      // });
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    enterItem: function enterItem(item) {
      // console.log(item);
      // this.checkItem = item;
      this.$router.push({
        path: '/formReview/reviewCenter/processMain',
        query: {
          item: JSON.stringify(item),
          type: 0
        }
      });
      // getApplyProcessFormByFormId(item).then(res => {
      //     console.log(res);
      //     if (res.data.code == 200) {
      //         if (res.data.data == null) {
      //             this.$message.error('请设计表单后再发起申请');
      //             return;
      //         }
      //         this.versionId = res.data.data.id;
      //         this.formName = item.formName;
      //         this.jsonData = JSON.parse(res.data.data.formData.value);
      //         console.log('this.jsonData==', this.jsonData);
      //         this.showDrawer();
      //     }
      // });
    },
    queryProcessApplyFormLists: function queryProcessApplyFormLists() {
      var _this = this;
      queryProcessApplyForm({
        formName: this.form.formName
      }).then(function (res) {
        if (res.data.code == 200) {
          _this.processApplyFormLists = res.data.data;
        }
      });
    },
    showDrawer: function showDrawer() {
      // this.$router.push({
      //   path: '/formReview/reviewCenter/processApply',
      //   query: {getMyApplyDetailsById
      //     formId: this.checkItem.formId
      //   }

      // })
      this.visible = true;
    },
    onClose: function onClose() {
      this.visible = false;
    },
    saveDraft: function saveDraft() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.$refs.addForm.validate(function (valid) {
                if (valid) {
                  _this2.$refs.generateForm.getData().then(function (data) {
                    formFillSave({
                      formId: _this2.checkItem.formId,
                      versionId: _this2.versionId,
                      fillData: data,
                      organId: _this2.formObject.organPostId[0],
                      postId: _this2.formObject.organPostId[1]
                    }).then(function (res) {
                      if (res.data.code == 200) {
                        _this2.$message.success('保存成功');
                        _this2.onClose();
                      }
                    });
                  });
                }
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this3.$refs.addForm.validate(function (valid) {
                if (valid) {
                  // 处理抄送数据

                  // organData
                  // actorId: 20000
                  // actorName: "党委组织架构"

                  // postData
                  // actorId: (...)
                  // actorName: (...)
                  // organId: (...)

                  // userData
                  // actorId: (...)
                  // actorName: (...)

                  // copyType text,typeId_ text,userId text,organId text,

                  var copyManData = new Array();

                  // let organData = this.usersList.organData.map(item => {
                  //   return {
                  //     copy_type: 2,
                  //     type_id: '',
                  //     organ_id: item.actorId,
                  //     post_id: '',
                  //     user_id: ''
                  //   }
                  // })

                  // let postData = this.usersList.postData.map(item => {
                  //   return {
                  //     copy_type: 1,
                  //     type_id: '',
                  //     organ_id: item.organId,
                  //     post_id: item.actorId,
                  //     user_id: ''
                  //   }
                  // })

                  // let userData = this.usersList.userData.map(item => {
                  //   return {
                  //     copy_type: 0,
                  //     type_id: '',
                  //     organ_id: '',
                  //     post_id: '',
                  //     user_id: item.actorId
                  //   }
                  // })

                  // copyManData = [...postData, ...organData, ...userData]

                  _this3.$refs.generateForm.getData().then(function (data) {
                    formFillSave({
                      formId: _this3.checkItem.formId,
                      versionId: _this3.versionId,
                      fillData: data,
                      organId: _this3.formObject.organPostId[0],
                      postId: _this3.formObject.organPostId[1]
                    }).then(function (res) {
                      if (res.data.code == 200) {
                        startProcess({
                          formName: _this3.checkItem.formName,
                          formId: _this3.checkItem.formId,
                          versionId: _this3.versionId,
                          fillData: data,
                          fillId: res.data.data
                        }).then(function (res) {
                          if (res.data.code === 200) {
                            _this3.onClickPublishThen(res.data.data);
                          }
                        });
                      } else {
                        _this3.$message.error(res.data.message);
                      }
                    });
                  }).catch(function (e) {});
                }
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    onClickPublishThen: function onClickPublishThen(procInsId) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, param;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this4.procInsId = procInsId;
              _context3.n = 1;
              return nextFlowNode({
                procInsId: _this4.procInsId
              });
            case 1:
              res = _context3.v;
              if (res.data.code == 200) {
                param = {
                  procInsId: _this4.procInsId,
                  nextNodeCliamUserId: '',
                  nextNodeUserType: '',
                  comment: '发起流程申请',
                  processStatus: 1
                };
                if (res.data.data == undefined) {
                  _this4.completeTask(param);
                } else if (Object.keys(res.data.data).length > 0) {
                  _this4.nextAuditUserType = res.data.data.type;
                  if (_this4.nextAuditUserType == 'labelType') {
                    _this4.completeTask(param);
                    // this.auditUserVisible = true;
                    // this.nextAuditUsers = res.data.data.userList;
                    // this.nextAuditUserFlag = true;
                  } else {
                    _this4.completeTask(param);
                  }
                }
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    completeTask: function completeTask(param) {
      var _this5 = this;
      complete(param).then(function (res) {
        if (res.data.code == 200) {
          _this5.$message.success('提交成功');
          _this5.onClose();
          // this.$router.push({
          //     path: '/formReview/reviewCenter/viewProcess',
          //     query: { procInsId: this.procInsId }
          // })
        }
      });
    }
  },
  created: function created() {
    this.queryProcessApplyFormLists();
    var userInfo = this.userInfo;
    // 级联数据处理
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList
      };
    });
  }
};